import { createContext } from 'react';

export interface IProductEditHistoryContext {
  historyData: any;
  historyLoading: boolean;
  expandHistoryAndScroll: (name: string) => void;
}

export const ProductEditHistoryContext = createContext<IProductEditHistoryContext | null>(null);
